import { Box, Chip, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const AccountText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '0.95rem',
  letterSpacing: 0.2,
}));

export const NameText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.primary,
  fontSize: '0.9rem',
}));

export const RolesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
}));

export const RoleChip = styled(Chip)(({ theme }) => ({
  height: 22,
  fontSize: '0.75rem',
  fontWeight: 500,
  backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.22 : 0.15),
  color: theme.palette.mode === 'dark' ? theme.palette.info.light : theme.palette.info.dark,
  '& .MuiChip-label': {
    padding: theme.spacing(0, 0.75),
  },
}));

export const ExtraRolesChip = styled(Chip)(({ theme }) => ({
  height: 22,
  fontSize: '0.75rem',
  fontWeight: 600,
  backgroundColor: alpha(theme.palette.text.secondary, theme.palette.mode === 'dark' ? 0.25 : 0.15),
  color: theme.palette.text.secondary,
  '& .MuiChip-label': {
    padding: theme.spacing(0, 0.75),
  },
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
}));
